var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiHomeSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 14.6797H9.28125C8.9375 14.6797 8.65625 14.3984 8.65625 14.0547V11.0859C8.65625 10.3359 8.0625 9.74219 7.3125 9.74219C6.5625 9.74219 5.96875 10.3359 5.96875 11.0859V14.0547C5.96875 14.3984 5.6875 14.6797 5.34375 14.6797H0.625C0.28125 14.6797 0 14.3984 0 14.0547V6.05469C0 5.49219 0.28125 4.96094 0.71875 4.64844L7 0.117188C7.21875 -0.0390625 7.5 -0.0390625 7.71875 0.117188L14 4.64844C14.4375 4.96094 14.7188 5.49219 14.7188 6.05469V14.0859C14.6875 14.3984 14.4062 14.6797 14.0625 14.6797ZM9.90625 13.4609H13.4688V6.05469C13.4688 5.89844 13.375 5.74219 13.25 5.64844L7.34375 1.36719L1.4375 5.61719C1.3125 5.71094 1.21875 5.86719 1.21875 6.02344V13.4297H4.78125V11.0859C4.78125 9.67969 5.9375 8.52344 7.34375 8.52344C8.75 8.52344 9.90625 9.67969 9.90625 11.0859V13.4609Z",
    fill: "#FFD822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiHomeSelected);
export default __webpack_public_path__ + "static/media/bi-home-selected.5347e68d29de7d5cd0876d2e8b8f1747.svg";
export { ForwardRef as ReactComponent };